import { ComparatorStep } from '@kizi/comparator-core';

const overview: ComparatorStep = {
  path: 'overview',
  name: 'overview',
  fields: [
    {
      name: 'requestLogId',
    },
    {
      name: 'selectedProduct',
      validator: 'required',
    },
    {
      name: 'hasIncentive',
    },
    {
      name: 'comparisonProducts',
    },
    {
      name: 'filters',
      value: JSON.stringify({
        showPriceMode: ['month'],
        rivm: [],
        Tandheelkundige_hulp_vanaf_18_jaar: ['-1'],
        Fysiotherapie: ['-1'],
        Zwangerschap_en_bevalling: ['-1'],
        Brillen_en_lenzen: ['-1'],
        Hulp_in_het_buitenland: ['-1'],
        Alternatieve_geneeswijzen: ['-1'],
        Anticonceptie: ['-1'],
        freeChoiceOfCaregiver: [],
        strictestLevelNewInsured: [],
        providerName: [],
      }),
    },
    {
      name: 'defaultFilters',
      value: JSON.stringify({
        showPriceMode: ['month'],
        rivm: [],
        Tandheelkundige_hulp_vanaf_18_jaar: ['-1'],
        Fysiotherapie: ['-1'],
        Zwangerschap_en_bevalling: ['-1'],
        Brillen_en_lenzen: ['-1'],
        Hulp_in_het_buitenland: ['-1'],
        Alternatieve_geneeswijzen: ['-1'],
        Anticonceptie: ['-1'],
        freeChoiceOfCaregiver: [],
        strictestLevelNewInsured: [],
        providerName: [],
      }),
    },
    {
      name: 'dynamicFiltersToListen',
      value: JSON.stringify([
        'showPriceMode',
        'Tandheelkundige_hulp_vanaf_18_jaar',
        'Fysiotherapie',
        'Zwangerschap_en_bevalling',
        'Brillen_en_lenzen',
        'Hulp_in_het_buitenland',
        'Alternatieve_geneeswijzen',
        'Anticonceptie',
        'HT',
        'ORTO',
      ]),
    },
    {
      name: 'defaultDynamicFiltersToListen',
      value: JSON.stringify([
        'showPriceMode',
        'Tandheelkundige_hulp_vanaf_18_jaar',
        'Fysiotherapie',
        'Zwangerschap_en_bevalling',
        'Brillen_en_lenzen',
        'Hulp_in_het_buitenland',
        'Alternatieve_geneeswijzen',
        'Anticonceptie',
        'HT',
        'ORTO',
      ]),
    },
    {
      name: 'isLoadingProducts',
      value: 'true',
    },
    {
      name: 'careGivers',
      value: '[]',
    },
    {
      name: 'showAllProducts',
      value: 'false',
    },
    {
      name: 'careType',
      active: true,
    },
  ],
};

export default overview;
